var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.4771 15.5229 0 10 0C4.47742 0 0 4.4771 0 10C0 15.5229 4.47742 20 10 20C15.5229 20 20 15.5229 20 10Z",
    fill: "#FF8A7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3978 11.7197H8.59721L8.16406 3.69141H11.8303L11.3978 11.7197ZM8.19822 14.6898C8.19822 14.0901 8.37516 13.6688 8.7287 13.4252C9.08224 13.1822 9.50217 13.0604 9.98913 13.0604C10.4696 13.0604 10.8828 13.1822 11.228 13.4252C11.5728 13.6688 11.7456 14.0901 11.7456 14.6898C11.7456 15.2612 11.5728 15.6744 11.228 15.9287C10.8828 16.1833 10.4696 16.3106 9.98913 16.3106C9.50217 16.3106 9.08224 16.1833 8.7287 15.9287C8.37516 15.6744 8.19822 15.2612 8.19822 14.6898Z",
    fill: "#FEF3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.c7deef050600a7410835a04f1a1c3533.svg";
export { ForwardRef as ReactComponent };